// import { to } from 'nh-utils'
// import api from 'lib/api'

export const getPeople = () => [] // TODO: resolving how to call mock api to(api.get('/people'))
